import { render, staticRenderFns } from "./OlderConsumers.vue?vue&type=template&id=68826136&scoped=true"
import script from "./OlderConsumers.vue?vue&type=script&lang=js"
export * from "./OlderConsumers.vue?vue&type=script&lang=js"
import style0 from "./OlderConsumers.vue?vue&type=style&index=0&id=68826136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68826136",
  null
  
)

export default component.exports